module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('approval-remarks', {
    attrs: {
      "row-data": _vm.actionData,
      "steps": _vm.actionData.steps,
      "legal-step": 3
    }
  }), _vm._v(" "), (_vm.isBackhaul) ? _c('section', [(_vm.isTowerCo() && _vm.actionData.subActionType === 'CUST') ? _c('backhaul-customer', {
    attrs: {
      "sharer-id": _vm.actionData.organisation_id,
      "site-id": _vm.actionData.site_id,
      "action-id": _vm.actionData.id,
      "is-request": true
    }
  }) : _c('backhaul-provider', {
    attrs: {
      "provider-id": _vm.actionData.provider_id,
      "site-id": _vm.actionData.site_id,
      "action-id": _vm.actionData.id,
      "editable": _vm.isTelco() ? false : true,
      "is-request": true
    }
  })], 1) : _vm._e(), _vm._v(" "), (_vm.isTowerCo() && _vm.canAccess('finance')) ? _c('section', [_c('el-form', {
    attrs: {
      "inline": true
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "Agreement Type"
    }
  }, [_c('el-select', {
    attrs: {
      "placeholder": "Select",
      "filterable": "",
      "allow-create": "",
      "disabled": !_vm.canAccess('finance') || _vm.disabled
    },
    model: {
      value: (_vm.step3.docType),
      callback: function($$v) {
        _vm.$set(_vm.step3, "docType", $$v)
      },
      expression: "step3.docType"
    }
  }, _vm._l((_vm.types), function(item) {
    return _c('el-option', {
      key: item.value,
      attrs: {
        "label": item.label,
        "value": item.value
      }
    })
  }), 1)], 1)], 1), _vm._v(" "), _c('p', [_vm._v("Agreement Type: "), _c('b', [_vm._v(_vm._s(_vm.step3.docType))])]), _vm._v(" "), (!_vm.disabled) ? _c('el-collapse', {
    attrs: {
      "accordion": ""
    },
    model: {
      value: (_vm.accordion),
      callback: function($$v) {
        _vm.accordion = $$v
      },
      expression: "accordion"
    }
  }, [(_vm.isTowerCo()) ? _c('el-collapse-item', {
    attrs: {
      "title": "Finance Apprvoal of Legal Document",
      "name": "FinApprove"
    }
  }, [_c('el-alert', {
    attrs: {
      "type": "info",
      "title": 'Approval of ' + (_vm.step3.docType ? _vm.step3.docType : 'legal documents'),
      "show-icon": "",
      "closable": false
    }
  }, [_c('check-box', {
    attrs: {
      "no-form": ""
    },
    on: {
      "change": _vm.legalChecked
    },
    model: {
      value: (_vm.step3.legalApproved),
      callback: function($$v) {
        _vm.$set(_vm.step3, "legalApproved", $$v)
      },
      expression: "step3.legalApproved"
    }
  }, [_vm._v(_vm._s((_vm.step3.docType ? _vm.step3.docType : 'Legal Document')))]), _vm._v(" "), (_vm.step.approved) ? _c('span', [_c('b', [_vm._v(_vm._s(_vm.formatDate(_vm.step.approved_at)))]), _vm._v(" by "), _c('b', [_vm._v(_vm._s(_vm.step.approved_by))])]) : _vm._e()], 1), _vm._v(" "), (this.isActive(this.actionData)) ? _c('el-alert', {
    attrs: {
      "type": "info1",
      "title": "Progress Remarks",
      "show-icon": ""
    }
  }) : _vm._e(), _vm._v(" "), _c('html-input', {
    attrs: {
      "disabled": _vm.isViewOnly() || !this.isActive(this.actionData)
    },
    model: {
      value: (_vm.step.remarks),
      callback: function($$v) {
        _vm.$set(_vm.step, "remarks", $$v)
      },
      expression: "step.remarks"
    }
  })], 1) : _vm._e(), _vm._v(" "), (_vm.isTowerCo() && !_vm.disabled && _vm.step.actionType === 'RTS') ? _c('el-collapse-item', {
    attrs: {
      "title": "Create Sharer",
      "name": "Sharer"
    }
  }, [_c('el-row', [(!_vm.step3.saved) ? _c('h2', [_c('strong', {
    staticClass: "text-success"
  }, [_vm._v("Add")]), _vm._v(" New Sharer")]) : _c('h3', [_vm._v("Sharer already created")])]), _vm._v(" "), _c('licensee-form', {
    attrs: {
      "site-id": _vm.rowData.site_id,
      "tower-id": _vm.site.siteId,
      "sharer-name": _vm.actionData.organisation.name,
      "sharer-id": _vm.actionData.organisation.id,
      "editable": _vm.step3.saved,
      "saved": _vm.step3.saved,
      "sharer-site-id": _vm.step2p2.state.siteId,
      "service-type": _vm.step2p2.state.serviceType,
      "spectrum-band": _vm.step2p2.state.spectrumBand,
      "equipment": _vm.step2.equipment
    }
  })], 1) : _vm._e()], 1) : _vm._e()], 1) : _c('section', [(_vm.isTowerCo()) ? _c('div', [(this.isActive(this.actionData) && _vm.step.remarks) ? _c('el-alert', {
    attrs: {
      "type": "info",
      "title": "Progress Remarks",
      "closable": false,
      "show-icon": ""
    }
  }) : _vm._e(), _vm._v(" "), _c('html-input', {
    attrs: {
      "disabled": "",
      "no-form": ""
    },
    model: {
      value: (_vm.step.remarks),
      callback: function($$v) {
        _vm.$set(_vm.step, "remarks", $$v)
      },
      expression: "step.remarks"
    }
  })], 1) : _c('div', [(this.isActive(this.actionData)) ? _c('el-alert', {
    attrs: {
      "type": "info",
      "title": "Progress Remarks",
      "closable": false,
      "show-icon": ""
    }
  }) : _vm._e(), _vm._v(" "), _c('html-input', {
    attrs: {
      "no-form": ""
    },
    model: {
      value: (_vm.step.remarks),
      callback: function($$v) {
        _vm.$set(_vm.step, "remarks", $$v)
      },
      expression: "step.remarks"
    }
  })], 1)])], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-39b9c37d"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/requests/workflow/step3.vue
// module id = 1425
// module chunks = 0